(function ($) {
    'use strict';


    const VetCheckout = {
        termsInput: $('input#wc_terms'),
        mainSpinner: $('.spinner-main'),
        form: $('form.woocommerce-checkout'),
        submitButton: $('#place_order'),
        vatPayerCheckbox: $('#company_vat_payer'),

        boot: function() {
            this.initTermsCheckboxListener();
            this.initLegalPersonVatCheckboxListener();
            this.toggleCompanyVatNrField();
        },
        initTermsCheckboxListener: function() {
            const $this = VetCheckout;

            this.form.on('submit', function(e){
                $this.termsInput.removeClass('invalid');
                $('#place_order').addClass('loading');
                //self.mainSpinner.addClass('loaded');

                if (!$('input#wc_terms').is(':checked')) {
                    $this.termsInput.addClass('invalid');
                    $('#place_order').removeClass('loading');
                    e.preventDefault();
                }
            });
        },
        toggleCompanyVatNrField: function() {
            const $this = VetCheckout;

            if ($this.vatPayerCheckbox.is(':checked')) {
                $this.form.find('#company_vat_nr').parent().parent().removeClass('hide');
            } else {
                $this.form.find('#company_vat_nr').parent().parent().addClass('hide');
            }
        },
        initLegalPersonVatCheckboxListener: function() {
            const $this = VetCheckout;

            $this.vatPayerCheckbox.on('change', function() {
                $this.toggleCompanyVatNrField();
            });
        }
    }

    VetCheckout.boot();

})(jQuery);



jQuery(document).ready(function($) {
    const checkoutBlock = $('.checkout.woocommerce-checkout');
    const checkoutUpdatingClass = 'checkout-updating';
    const companyBillingFields = $('.woocommerce-billing-fields__field-wrapper.company-fields');
    const form = $('form.woocommerce-checkout');


    const VetCheckout = {
        checkoutBlocksTitles : $('.woocommerce-billing-fields > h3, .woocommerce-shipping-fields__fields-wrapper > h3, .woocommerce-shipping-fields > h3, .woocommerce-checkout-payment__inner > h3, .woocommerce-additional-fields > h3'),
        init : function () {
            this.toggleCheckoutBlocksOn();

        },
        toggleCheckoutBlocksOn() {
            //remove active click events first
            this.toggleCheckoutBlocksOff();

            this.checkoutBlocksTitles.on('click', function() {
                $(this).toggleClass('closed');
                $(this).parent().toggleClass('closed');
            });
        },
        toggleCheckoutBlocksOff() {
            this.checkoutBlocksTitles.off('click');
        },
        updateAddressField(inputName, inputValue) {
        },
        initTermsCheckboxListener() {

        },
        updateShippingMethods() {

        }
    }

    if ( $('body').hasClass('woocommerce-checkout') ) {
        $('.checkout-login-buttons a.noreg').on('click', function (e) {
            e.preventDefault();

            $('.checkout-login-buttons').fadeOut();
        });

        change_payment();
        updateShippingMethods();
        initRemoveCoupon();

        $('input[name="billing_person_type"]').on('change', function () {
            change_payment();

            if ( form.find('input[value="legal"]').is(':checked') ) {
                setIndividualAddressVisibility(false);
            } else {
                setIndividualAddressVisibility(true);
            }
        });

        $('select[name="billing_country"]').on('change', function () {
            change_payment(true);
        });

        VetCheckout.init();

        $( document.body ).on('update_checkout', function(){
            checkoutBlock.addClass(checkoutUpdatingClass);
            const venipak = form.find('input[value^="shopup_venipak_shipping_pickup_method"]');

            if ( venipak.is(':checked') ) {
                window.venipakShipping.init();
            } else {
                $('#venipak_pickup_point').hide();
                $('#venipak_pickup_point + .select2').hide();
            }
        });

        $( document.body ).on('updated_checkout', function(){
            $(document.body).trigger('updated_shipping_method');
            updateShippingMethods();
            checkoutBlock.removeClass(checkoutUpdatingClass);

            if ( $('body').hasClass('woocommerce-checkout') && $('body').hasClass('wc-coupon-removed') ) {
                location.reload();
            }

            VetCheckout.toggleCheckoutBlocksOn();
        });

        $( document.body ).on('payment_method_selected', function(){
            $(document.body).trigger('update_checkout');
        });

        $( document.body ).on('updated_shipping_method', function(){
            checkMinTotalPrice();
            setShippingFieldVisibility();
        });

        $( document.body ).on('checkout_error', function(){
            $('html, body').stop();
            const errorCount = $('.woocommerce-error li').length;

            if ( errorCount > 0 ) {
                form.find('.button-error-notice').removeClass('hide');
            } else {
                form.find('.button-error-notice').addClass('hide');
            }

            const noticeBlock = $('#main-nav');

            $('html').animate(
                {
                    scrollTop: noticeBlock.offset().top,
                },
                500
            );

            // remove button spinner state
            $('#place_order').removeClass('loading');

            // remove main fixed spinner overlay state
            $('.spinner-main').removeClass('loaded');

            // extra safety: if spinner element uses these classes, force-hide it too
            $('.spinner-main.vet-spinner.vet-spinner--large.vet-spinner--fixed')
                .removeClass('loaded')
                .hide();
        });
    }

    if ( form.find('input[value="legal"]').is(':checked') ) {
        companyBillingFields.removeClass('hide');
        form.addClass('hide-legal-fields');

        setIndividualAddressVisibility(false);
    }

    form.find('input[name="shipping_address_switch"]').on('change', function () {
        form.find('.shipping_address').toggleClass('hide');
        form.find('.shipping_address_other').toggleClass('hide');
    });

    const $otherShippingSelect = form.find('select[name="other_shipping_address_select"]');

    $otherShippingSelect.on('change', function () {
        const parent = $('form.woocommerce-checkout .shipping_address_other');
        const selected = $otherShippingSelect.find('option:selected');

        const selectedAddressData = {
            'shipping_custom_address_1': selected.data('address_1') || '',
            'shipping_custom_address_2': selected.data('address_2') || '',
            'shipping_custom_address_city': selected.data('city') || '',
            'shipping_custom_address_postcode': selected.data('postcode') || '',
            'shipping_custom_address_phone': selected.data('phone') || '',
            'shipping_custom_address_country': selected.data('country') || ''
        };

        for (let inputName in selectedAddressData) {
            parent.find('input[name="' + inputName + '"]').val(selectedAddressData[inputName]);

            if (selectedAddressData[inputName]) {
                parent.find('label[for="' + inputName + '"]').addClass('animate-label');
            } else {
                parent.find('label[for="' + inputName + '"]').removeClass('animate-label');
            }
        }
    });

    if ($otherShippingSelect.length && $otherShippingSelect.val()) {
        $otherShippingSelect.trigger('change');
    }


    /**
     * @dsc
     */
    function updateShippingMethods() {
        const shippingOptions = $('#shipping_method').find('label.switch');
        const shippingOptionsCount = shippingOptions.length;

        if (shippingOptionsCount === 1) {
             $( shippingOptions[0] ).find('input').addClass('option-selected');
        }
    }

    function setIndividualAddressVisibility(show = true) {
        const billingAddress1 = $('#billing_address_1_field');
        const billingAddress2 = $('#billing_address_2_field');
        const billingCity = $('#billing_city_field');
        const billingPostcode = $('#billing_postcode_field');

        if (show) {
            billingAddress1.removeClass('hide');
            billingAddress2.removeClass('hide');
            billingCity.removeClass('hide');
            billingPostcode.removeClass('hide');
        } else {
            billingAddress1.addClass('hide');
            billingAddress2.addClass('hide');
            billingCity.addClass('hide');
            billingPostcode.addClass('hide');
        }
    }

    function hasCheckoutParams() {
        return typeof wc_checkout_params !== 'undefined' && !!wc_checkout_params && !!wc_checkout_params.ajax_url;
    }

    function change_payment(reload = false) {
        if (!hasCheckoutParams()) {
            return;
        }

        if ($('input[name="billing_person_type"]').length > 0 && $('select[name="billing_country"]').length > 0) {
            $.ajax({
                type: 'POST',
                url: wc_checkout_params.ajax_url,
                data: {
                    action: 'vet_change_payments',
                    country: $('select[name="billing_country"]').val(),
                    pers_type: $('input[name="billing_person_type"]:checked').val()
                },
                success: function () {
                    $(document.body).trigger('update_checkout');

                    if (reload) {
                        location.reload();
                    }
                }
            });
        }
    }

    /**
     *
     */
    function checkMinTotalPrice() {
        const isCheckoutPage = VetfondsJs.vetShopData.isCheckoutPage;
        const canBuy =  VetfondsJs.vetShopData.cartTotalPrice >= VetfondsJs.vetShopData.minOrderPrice;
        const reviewOrderMinPriceBlock = $('.woocommerce-checkout-review-order-table .table-foot .min-order');
        const placeOrderErrorMsg = $('.place-order .button-error-notice')
        const placeOrderButton = $('#place_order');

        if (isCheckoutPage) {
            if (canBuy) {
                placeOrderButton.removeAttr('disabled');
                reviewOrderMinPriceBlock.hide();

                if (!placeOrderErrorMsg.hasClass('hide')) {
                    placeOrderErrorMsg.addClass('hide');
                }
            } else {
                placeOrderButton.attr('disabled', '');
                placeOrderErrorMsg.removeClass('hide');
                reviewOrderMinPriceBlock.show();
            }
        }
    }

    /**
     * @dsc
     */
    function setShippingFieldVisibility() {
        const localP = form.find('input[value^="local_pickup"]');
        const courier = form.find('input[value^="flat_rate"]');
        const omniva = form.find('input[value^="omnivalt_pt"]');
        const venipak = form.find('input[value^="shopup_venipak_shipping_courier_method"]');
        const venipakPickup = form.find('input[value^="shopup_venipak_shipping_pickup_method"]');
        const shippingFields = form.find('.woocommerce-shipping-fields');
        const omnivaPickupOptionsBlock = $('.terminal-container');

        if ( localP.is(':checked') ) {
            shippingFields.addClass('hide');
        } else if ( venipak.is(':checked') ) {
            shippingFields.removeClass('hide');
        } else if ( omniva.is(':checked') ) {
            shippingFields.addClass('hide');
        } else if ( courier.is( ':checked' ) ) {
            shippingFields.removeClass('hide');
        } else if ( venipakPickup.is( ':checked' ) ) {
            shippingFields.addClass('hide');
        } else {

        }

        //set Omniva pickup point select visibility
        if ( omniva.is(':checked') ) {
            if (omnivaPickupOptionsBlock) {
                omnivaPickupOptionsBlock.show();
            }
        } else {
            if (omnivaPickupOptionsBlock) {
                omnivaPickupOptionsBlock.hide();
            }
        }
    }

    function initRemoveCoupon() {
        $ ( 'a.woocommerce-remove-coupon ').on( 'click', function() {
            $('body').addClass('wc-coupon-removed');
        } );
    }


    /**
     * On Person type change
     */
    form.on('change', 'input[name="billing_person_type"]', function () {
        if ( form.find('input[name="billing_person_type"]:checked').val() == 'legal' ) {
            companyBillingFields.removeClass('hide');
            form.addClass('hide-legal-fields');
        } else {
            companyBillingFields.addClass('hide');
            form.removeClass('hide-legal-fields');
        }
    });

    form.on('change', 'input', function () {
        form.find('.button-error-notice').addClass('hide');
    });

    form.find('input[name^="shipping_method"]').on('change', function () {
        setShippingFieldVisibility();
    });

    /*jQuery(document.body).on('checkout_error', function () {
        $('html, body').stop();
    });*/
});

(function ($) {
    function isOmnivaSelected() {
        const $selectedMethod = $('input[name^="shipping_method"]:checked');

        return $selectedMethod.length && $selectedMethod.val().indexOf('omnivalt') !== -1;
    }

    function hasVisibleOmnivaContainer() {
        const $container = $('.omnivalt_terminal_container');

        return $container.length && $container.is(':visible');
    }

    function updateOmnivaPlaceholder() {
        const $placeholder = $('.wc-omniva-shipping-terminals-loading');

        if (!$placeholder.length) {
            return;
        }

        if (!isOmnivaSelected()) {
            $placeholder.hide();
            return;
        }

        if (hasVisibleOmnivaContainer()) {
            $placeholder.hide();
        } else {
            $placeholder.show();
        }
    }

    function watchOmnivaContainer() {
        let attempts = 0;
        const maxAttempts = 40;

        const interval = setInterval(function () {
            updateOmnivaPlaceholder();
            attempts++;

            if (hasVisibleOmnivaContainer() || attempts >= maxAttempts) {
                clearInterval(interval);
            }
        }, 250);
    }

    $(document).ready(function () {
        updateOmnivaPlaceholder();

        $(document.body).on('change', 'input[name^="shipping_method"]', function () {
            updateOmnivaPlaceholder();

            if (isOmnivaSelected()) {
                watchOmnivaContainer();
            }
        });

        $(document.body).on('update_checkout', function () {
            updateOmnivaPlaceholder();
        });

        $(document.body).on('updated_checkout updated_shipping_method', function () {
            updateOmnivaPlaceholder();

            if (isOmnivaSelected()) {
                watchOmnivaContainer();
            }
        });
    });
})(jQuery);